import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_ButtonGroup = _resolveComponent("ButtonGroup")

  return (_openBlock(), _createBlock(_component_ButtonGroup, {
    modelValue: _ctx.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.value) = $event)),
    options: $props.options,
    class: "button-group"
  }, {
    option: _withCtx(({option}) => [
      (!_ctx.$responsive.mobile)
        ? (_openBlock(), _createBlock(_component_Icon, {
            key: 0,
            icon: option.icon,
            size: "1.6rem",
            "stroke-width": "1",
            stroke: "var(--brand-700)"
          }, null, 8 /* PROPS */, ["icon"]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", null, _toDisplayString(option.title), 1 /* TEXT */)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue", "options"]))
}